import {
	getAlgoliaSearchParametersConfiguration,
	getCurrentAlgoliaIndexName,
	getInstantSearchClient,
} from "../../components/search/client";
import { initSearchBox } from "../../components/search/searchbox/searchbox";
import { initExtranetResults } from "../../components/search/extranet-results/extranet-results";
import {
	initStats,
	updateSearchSummary,
} from "../../components/search/result-bar/result-bar";
import { initSortBy } from "../../components/search/sort-by/connect-sort-by.js";
import { showLoader } from "../../components/search/loader/loader.js";

export class ExtranetSearch extends HTMLElement {
	#instantSearch;

	/**
	 * Creates an instance of ExtranetSearch.
	 */
	constructor() {
		super();

		this.#init();
	}

	/**
	 * Updates the state of the search component.
	 * @private
	 * @param {string} query - The search query.
	 */
	#updateState(query) {
		const currentURL = new URL(window.location);

		if (query.trim() === "") {
			currentURL.searchParams.delete("query");
		} else {
			currentURL.searchParams.set("query", query);
		}

		window.history.replaceState({}, "", currentURL);
		updateSearchSummary(query);
	}

	/**
	 * Initializes the search component.
	 * @private
	 */
	async #init() {
		const searchBoxOptions = {
			container: this.querySelector("search"),
			queryHook: (query, search) => {
				// This function is called when the user submits the search form.
				// Critically _not_ during the initial search on page load.
				this.#updateState(query);
				search(query);
			},
		};

		this.#instantSearch = await getInstantSearchClient();

		this.#instantSearch.addWidgets([
			initSearchBox(searchBoxOptions),
			initExtranetResults(),
			initStats(),
			initSortBy(".SortBy--mobile"),
			initSortBy(".SortBy"),
			getAlgoliaSearchParametersConfiguration(),
		]);

		this.#instantSearch.start();

		showLoader();

		const searchParams = new URLSearchParams(window.location.search);
		const query = searchParams.get("query") || "";

		updateSearchSummary(query);

		// This ensures that the query passed via the URL is reflected in the search box
		// and passed to the InstantSearch client.
		const indexName = getCurrentAlgoliaIndexName();
		this.#instantSearch.setUiState({
			[indexName]: {
				query,
			},
		});
	}
}

customElements.define("app-extranet-search", ExtranetSearch);
